import { useState, useEffect, useCallback } from "react";

/**
 * Hook pour gérer le partage en temps réel
 * Permet de synchroniser les recettes partagées entre les onglets
 */
const useRealtimeShare = () => {
  const [lastUpdate, setLastUpdate] = useState(Date.now());
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // Détecter les changements de connexion
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setLastUpdate(Date.now());
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Synchronisation entre onglets avec localStorage
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "recipe-shared" && e.newValue) {
        const data = JSON.parse(e.newValue);
        setLastUpdate(data.timestamp);
        console.log(
          "🔄 Nouvelle recette partagée détectée via localStorage:",
          data
        );
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Fonction pour notifier les autres onglets
  const notifyShare = useCallback((recipeId, recipeTitle) => {
    const data = {
      recipeId,
      recipeTitle,
      timestamp: Date.now(),
      action: "shared",
    };

    localStorage.setItem("recipe-shared", JSON.stringify(data));

    // Supprimer après 1 seconde pour éviter les doublons
    setTimeout(() => {
      localStorage.removeItem("recipe-shared");
    }, 1000);

    console.log("📢 Notification de partage envoyée:", data);
  }, []);

  // Fonction pour notifier la suppression
  const notifyUnshare = useCallback((recipeId, recipeTitle) => {
    const data = {
      recipeId,
      recipeTitle,
      timestamp: Date.now(),
      action: "unshared",
    };

    localStorage.setItem("recipe-unshared", JSON.stringify(data));

    setTimeout(() => {
      localStorage.removeItem("recipe-unshared");
    }, 1000);

    console.log("📢 Notification de suppression envoyée:", data);
  }, []);

  return {
    lastUpdate,
    isOnline,
    notifyShare,
    notifyUnshare,
  };
};

export default useRealtimeShare;
